import { TrackedExpandableContext } from '@objectiv/tracker-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { MarkdownPresentation } from '../../../features/assistant/components/Presentation/Presentation';
import { useChatStore } from '../../../stores/chatStore';

import styles from './styles.module.css';

import type { ComponentProps } from 'react';

interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

const CanvasSidebar: React.FC<SidebarProps> = ({ isOpen }) => {
  const { t } = useTranslation('assistant');
  const sidebarContent = useChatStore().sidebarContent;

  return (
    <TrackedExpandableContext<ComponentProps<'div'>>
      className={clsx(styles.sidebar, { [styles.sidebarOpen]: isOpen })}
      {...{ inert: !isOpen ? '' : undefined }}
      objectiv={{ Component: 'div', id: 'chat-presentation-sidebar', isVisible: isOpen }}
    >
      <div className={styles.sidebarHeader}>
        <h2>{t('chat.sidebar.title')}</h2>
        {/* <IconicSidebar onClick={toggleSidebar} className={styles.sidebarIcon} /> */}
      </div>
      <div className={styles.sidebarContent}>
        {!!sidebarContent && <MarkdownPresentation slides={sidebarContent} variables={{}} />}
      </div>
    </TrackedExpandableContext>
  );
};

export { CanvasSidebar };
